export default __webpack_public_path__ + "static/media/fileIcon.f4ca08d0.svg";